// src/components/navigation/Footer.js
export default function Footer() {
  return (
    <footer className="ftr-copyright">
      <p>© {new Date().getFullYear()} Turning Point Software. All rights reserved.</p>
    </footer>
  );
}
